import React, { Fragment, forwardRef, useEffect, useRef, useState } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import constants from '../../constants'
import { Button } from 'reactstrap'
import moment from 'moment'
import SkeletonTable from '../../components/SkeletonTable'
import { useQueryState } from 'use-location-state'
import PropTypes from 'prop-types'
import qs from 'query-string'
import { getUserContestList, clearUserContestExportData } from '../../actions/userContest'
import editIcon from "../../assests/images/edit-icon.svg"

const AdminContestManagement = forwardRef((props, excelRef) => {
  const authState = useSelector(state => state.auth)
  const { adminData, token } = authState
  const { userContestList } = useSelector(state => state.userContest)
  const permission = (adminData.aPermissions && adminData.aPermissions.length && adminData.aPermissions.find(e => e.eKey === 'USERCONTEST').eType) ? adminData.aPermissions.find(e => e.eKey === 'USERCONTEST').eType : adminData.eType === 'SUPER' ? constants.WRITE_PERMISSION : constants.NO_PERMISSION

  const [offset, setOffset] = useQueryState('pageSize', 10)
  const [list, setList] = useState([])
  const [activePageNo, setPageNo] = useQueryState('page', 1)
  const [startDate, setStartDate] = useQueryState('startDate', '')
  const [endDate, setEndDate] = useQueryState('endDate', '')
  const [order, setOrder] = useQueryState('order', 'desc')
  const [search, setSearch] = useQueryState('search', '')
  const [cType, setCType] = useQueryState('cType', '')
  const [cStatus, setCStatus] = useQueryState('cStatus', '')
  const [sort] = useQueryState('sortBy', 'dStartTime')
  const [loading, setLoading] = useState(false)
  const searchProp = props.search
  const startDateProp = props.startDate
  const endDateProp = props.endDate
  const openPickerProp = props.openPicker
  const contestStatusProp = props.contestFilter.status
  const contestTypeProp = props.contestFilter.type
  const previousProps = useRef({
    userContestList,
    searchProp,
    startDateProp,
    endDateProp,
    openPickerProp,
    contestStatusProp,
    contestTypeProp
    // excelExportData
  }).current


  const dispatch = useDispatch()
  useEffect(() => {
    if (props.location.state) {

      props.history.replace()
    }
    const page = 1
    const limit = offset
    const orderVal = 'desc'
    const obj = qs.parse(props.location.search)
    if (obj) {
      setPageNo(obj.page || page)
      setOffset(obj.pageSize || limit)
      setOrder(obj.order || orderVal)
    }
    const start = ((obj.page || page) - 1) * (obj.pageSize || limit)
    dispatch(getUserContestList(start, limit, sort, order, search, startDate, endDate, { cStatus, cType }, false ,"O", token))
    setLoading(true)

    return () => {
      dispatch(clearUserContestExportData())
    }
  }, [])



  useEffect(() => {
    if (previousProps.userContestList !== userContestList) {
      if (userContestList && userContestList.results) {
        setList(userContestList.results)
      } else if (userContestList && (!userContestList.results || !userContestList.results.length)) {
        setList([])
      }
      setLoading(false)
    }
    return () => {
      previousProps.userContestList = userContestList
    }
  }, [userContestList])

  useEffect(() => {
    if (previousProps.contestStatusProp !== contestStatusProp || previousProps.contestTypeProp !== contestTypeProp) {
      const start = 0
      const limit = offset
      dispatch(getUserContestList(start, limit, sort, order, search, startDate, endDate, { cStatus: contestStatusProp, cType: contestTypeProp }, false, "O",token))
      setCStatus(contestStatusProp)
      setCType(contestTypeProp)
      setPageNo(1)
      setLoading(true)
    }
    return () => {
      previousProps.contestStatusProp = contestStatusProp
      previousProps.contestTypeProp = contestTypeProp
    }
  }, [contestStatusProp, contestTypeProp])

  useEffect(() => {
    if (previousProps.startDateProp !== startDateProp || previousProps.endDateProp !== endDateProp) {
      if (startDateProp && endDateProp) {
        const start = 0
        const limit = offset

        dispatch(getUserContestList(start, limit, sort, order, search, startDateProp, endDateProp, { cStatus: contestStatusProp, cType: contestTypeProp }, false, "",token))
        setSearch(search || '')
        setStartDate(startDateProp)
        setEndDate(endDateProp)
        setPageNo(1)
        setLoading(true)
      }
    }
    return () => {
      previousProps.startDateProp = startDateProp
      previousProps.endDateProp = endDateProp
    }
  }, [startDateProp, endDateProp])

  useEffect(() => {
    const callSearchService = () => {
      const start = 0
      const limit = offset
      dispatch(getUserContestList(start, limit, sort, order, props.search, startDate, endDate, { cStatus, cType }, false,"O",token))
      setSearch(searchProp)
      setPageNo(1)
      setLoading(true)
    }
    if (previousProps.searchProp !== searchProp && props.flag) {
      const debouncer = setTimeout(() => {
        callSearchService()
      }, 1000)
      return () => {
        clearTimeout(debouncer)
        previousProps.searchProp = searchProp
      }
    }
    return () => {
      previousProps.searchProp = searchProp
    }
  }, [searchProp])

  

  return (
    <Fragment>
        <div className="table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th>Sr no.</th>
              <th>Contest Name</th>
              <th>
                Date &amp; Time
                <Button color="link" className="sort-btn">
                </Button>
              </th>
              <th>Status</th>
              <th>action
 
              </th>
            </tr>
          </thead>
          <tbody>
            {loading
              ? <SkeletonTable numberOfColumns={permission !== constants.NO_PERMISSION ? 9 : 10} />
              : (
                <Fragment>
                  {
                    list.map((data, i) => {
                      let dStartTime = moment(data.dStartTime).local().format('lll')
                      dStartTime = dStartTime === 'Invalid date' ? ' - ' : dStartTime
                      return (
                        <tr key={data._id}>
                          <td>{(((activePageNo - 1) * offset) + (i + 1))}</td>
                          <td>{data?.sName}</td>
                          <td>{dStartTime}</td>
                          <td>{data?.eStatus === data.eStatus === 'U' ? 'Upcoming' : data.eStatus === 'L' ? 'Live' : data.eStatus === 'CMP' ? 'Completed' : 'Cancel'}</td>
                          <td>
                          <ul className="action-list mb-0 d-flex">
                            {permission === constants.WRITE_PERMISSION
                              ? (
                              <li>
                                <Button color="link" className="edit" >
                                  <img src={editIcon} alt="Edit" />
                                  <span>Edit</span>
                                </Button>
                              </li>
                                )
                              : null}
                          </ul>
                          </td>
                        </tr>
                      )
                    })
                  }
                </Fragment>
                )}
          </tbody>
        </table>
      </div>
    </Fragment>
  )
})

AdminContestManagement.propTypes = {
  location: PropTypes.object,
  history: PropTypes.object,
  search: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  openPicker: PropTypes.bool,
  contestStatusProp: PropTypes.bool,
  contestFilter: PropTypes.bool,
  handleDateRangePicker: PropTypes.string,
  flag: PropTypes.bool
}
AdminContestManagement.displayName = AdminContestManagement
export default connect(null, null, null, { forwardRef: true })(AdminContestManagement)
